import { CommonModule, DOCUMENT } from "@angular/common";
import { Component, ElementRef, Inject, Input, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { AppPaths } from "projects/assist/src/app/app-routes";
import { Federations } from "projects/assist/src/app/organisation/models/federation";
import { SubscriptionService } from "projects/assist/src/app/organisation/services/subscription.service";
import { SettingsPaths } from "projects/assist/src/app/settings/settings-routes";
import { StartSettingSmallOrgDto } from "../../../../organisation/models/startsetting";
import { StartsettingsService } from "../../../../organisation/services/startsettings.service";
import { GlobalVariables } from "../../../services/global.service";
import { createRoutePath } from "../../../utils/route-util";
import { MenuItem } from "./models/menuItem";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbCollapseModule],
})
export class SidenavComponent implements OnInit {
  @Input() menuItems: MenuItem[] = [];
  global = GlobalVariables;
  federations = Federations;
  showOldAssist: boolean = false;
  @Input() mijnAssist: boolean = false;
  startSetting: StartSettingSmallOrgDto | null = null;
  hasVat = false;
  federationid: number | null = null;
  subscriptionTypeId: number | null = null;
  constructor(
    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public subscriptionService: SubscriptionService,
    private startsettingservice: StartsettingsService
  ) {}

  ngOnInit(): void {
    if (!this.mijnAssist)
      this.startsettingservice.getCurrent().subscribe((x) => {
        this.startSetting = x;
        if (this.startSetting != null && this.startSetting?.VatTypeId)
          this.hasVat = this.startSetting.VatTypeId > 1 && this.startSetting.VatTypeId != 5;
        this.federationid = this.startSetting?.Organization?.FederationId;
      });

    if (!this.mijnAssist)
      this.subscriptionService.getCurrent().subscribe((subscription) => {
        this.showOldAssist = subscription.SubscriptionTypeId != 5;
        this.subscriptionTypeId = subscription.SubscriptionTypeId;
      });

    this.menuItems.forEach((menuItem) => {
      menuItem.collapsed = true;
    });
  }

  toggleSidenav() {
    const sidenav = this.el.nativeElement.querySelector("#sidenav-main");
    const iconSidenav = this.el.nativeElement.querySelector("#iconSidenav");
    const body = this.document.body;
    const className = "g-sidenav-pinned";

    if (body.classList.contains(className)) {
      body.classList.remove(className);
      setTimeout(function () {
        sidenav.classList.remove("bg-white");
      }, 100);
      sidenav.classList.remove("bg-transparent");
    } else {
      body.classList.add(className);
      sidenav.classList.add("bg-white");
      sidenav.classList.remove("bg-transparent");
      iconSidenav.classList.remove("d-none");
    }
  }

  sidenavToggler() {
    let sidenavToggler = this.document.getElementsByClassName("sidenav-toggler")[0];
    let sidenavShow = this.document.getElementsByClassName("g-sidenav-show")[0];
    let toggleNavbarMinimize = this.document.getElementById("navbarMinimize");

    if (!sidenavShow.classList.contains("g-sidenav-hidden")) {
      sidenavShow.classList.remove("g-sidenav-pinned");
      sidenavShow.classList.add("g-sidenav-hidden");
      if (toggleNavbarMinimize) {
        toggleNavbarMinimize.click();
        toggleNavbarMinimize.setAttribute("checked", "true");
      }
    } else {
      sidenavShow.classList.remove("g-sidenav-hidden");
      sidenavShow.classList.add("g-sidenav-pinned");
      if (toggleNavbarMinimize) {
        toggleNavbarMinimize.click();
        toggleNavbarMinimize.removeAttribute("checked");
      }
    }
  }

  navigate(url: string | undefined) {
    if (url) this.router.navigateByUrl(createRoutePath([url]));
  }

  closeOnMobile() {
    let sidenavShow = this.document.getElementsByClassName("g-sidenav-show")[0];
    if (window) {
      if (window.innerWidth < 1200) {
        this.sidenavToggler();
      }
    }
  }

  navigateOnToggle(item: MenuItem) {
    const url = !item.collapsed ? null : item.route;
    if (url) this.router.navigateByUrl(createRoutePath([url]));
    item.collapsed = !item.collapsed;
  }

  createSettingsUrl() {
    return createRoutePath([AppPaths.Settings, SettingsPaths.Settings]);
  }
}
